import { Alert, IconButton } from '@mui/material';
import { SnackbarContent, CustomContentProps, useSnackbar } from 'notistack';
import React from 'react';
import { Icon } from '../../blocks/icons';
import styles from './SimpleAlert.module.scss';
import classNames from 'classnames';

interface SimpleAlertProps extends CustomContentProps {
	type: 'warning' | 'success';
}

export const SimpleAlert = React.forwardRef<HTMLDivElement, SimpleAlertProps>(
	( { id, message, variant }, ref ) => {
		const { closeSnackbar } = useSnackbar();
		return (
			<SnackbarContent ref={ ref }>
				<Alert
					variant='outlined'
					severity={
						variant === 'success'
							? variant
							: variant === 'warning'
								? 'error'
								: 'warning'
					}
					iconMapping={ {
						success: (
							<Icon
								type='check'
								className={ classNames( styles.icon, styles.success ) }
							/>
						),
						warning: (
							<Icon
								type='warning'
								className={ classNames( styles.icon, styles.error ) }
							/>
						),
					} }
					className={ classNames(
						styles.alert,
						variant === 'error' ? styles.error : undefined,
						// for Cypress, a legacy class
						variant === 'error'
							? 'toast__message--error'
							: 'toast__message--success'
					) }
					action={
						<IconButton onClick={ () => closeSnackbar( id ) }>
							<Icon
								type='cross'
								className={ classNames( styles.icon, styles.close ) }
							/>
						</IconButton>
					}
				>
					{ message }
				</Alert>
			</SnackbarContent>
		);
	}
);
